'use client'

import { LogoFull } from '@real-code-query/ui/Logo'
import { usePathname } from 'next/navigation'

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const isSignupRoute = pathname === '/auth/signup'

  if (isSignupRoute) {
    return <div className="flex min-h-screen flex-col">{children}</div>
  }

  return (
    <div className="flex min-h-screen flex-col">
      <div className="mx-auto pt-36">
        <LogoFull />
      </div>
      <div className="border-border-secondary bg-background-secondary mx-auto my-[100px] flex w-[400px] max-w-[350px] flex-col gap-4 rounded-md border p-8 md:max-w-full">
        {children}
      </div>
    </div>
  )
}
